import { FC, SVGProps } from "react";

export const QuantitySelectorRemoveSvg: FC<SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    className="fill-red-400"
    {...props}
  >
    <path d="M2.94519 16.6691C2.48299 16.6691 2.08833 16.5056 1.76121 16.1784C1.43408 15.8513 1.27051 15.4566 1.27051 14.9944V2.81499H0.0205078V1.46085H4.49965V0.331055H9.49965V1.46085H13.9788V2.81499H12.7288V14.9831C12.7288 15.4648 12.5669 15.8662 12.2431 16.1874C11.9193 16.5085 11.523 16.6691 11.0541 16.6691H2.94519ZM11.3746 2.81499H2.62465V14.9944C2.62465 15.0879 2.6547 15.1647 2.7148 15.2248C2.77491 15.2849 2.85171 15.315 2.94519 15.315H11.0541C11.1342 15.315 11.2077 15.2816 11.2745 15.2148C11.3413 15.148 11.3746 15.0746 11.3746 14.9944V2.81499ZM4.92035 13.44H6.27449V4.68999H4.92035V13.44ZM7.7248 13.44H9.07894V4.68999H7.7248V13.44Z" />
  </svg>
);
